import { render, staticRenderFns } from "./summary-statistics.vue?vue&type=template&id=d039212e&scoped=true&"
import script from "./summary-statistics.vue?vue&type=script&lang=js&"
export * from "./summary-statistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d039212e",
  null
  
)

export default component.exports